import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  d: "M8 8h8v8H8z",
  opacity: ".3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6 18h12V6H6v12zM8 8h8v8H8V8z"
})), 'StopTwoTone');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/StopTwoTone.js
// module id = 6512
// module chunks = 2